import React, { useEffect } from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import BottomNav from "../common/BottomNav";
import AppHeader from "../common/AppHeader";
import { useTranslation } from "react-i18next";
import styles from "../css/Contact.module.css";

export default function Contact() {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.pageContainer}>
      <AppHeader
        title={t("Contact.contact_us", "Contact Us")}
        showBack
      />

      {/* HERO CARD */}
      <div className={styles.heroCard}>
        <h2>{t("Contact.get_in_touch", "Get in Touch")}</h2>
        <p>
          {t(
            "Contact.help_text",
            "We are here to help you. Reach out to us anytime."
          )}
        </p>
      </div>

      {/* CONTACT OPTIONS */}
      <div className={styles.contactSection}>
        <a
          href="tel:+919140251119"
          className={styles.contactCard}
        >
          <div className={styles.iconBox}>
            <FaPhoneAlt />
          </div>

          <div className={styles.info}>
            <h4>{t("Contact.call_support", "Call Support")}</h4>
            <p>{t("Contact.phone", "+91 9140251119")}</p>
          </div>

          <span className={styles.action}>
            {t("Contact.call", "Call")}
          </span>
        </a>

        <a
          href="mailto:support@bhada24.com"
          className={styles.contactCard}
        >
          <div className={styles.iconBox}>
            <FaEnvelope />
          </div>

          <div className={styles.info}>
            <h4>{t("Contact.email_support", "Email Support")}</h4>
            <p>
              {t(
                "Contact.email",
                "support@bhada24.com"
              )}
            </p>
          </div>

          <span className={styles.action}>
            {t("Contact.email_btn", "Email")}
          </span>
        </a>

        <div className={styles.contactCard}>
          <div className={styles.iconBox}>
            <FaMapMarkerAlt />
          </div>

          <div className={styles.info}>
            <h4>{t("Contact.location", "Office Location")}</h4>
            <p>
              {t(
                "Contact.address",
                "Varanasi, Uttar Pradesh, India"
              )}
            </p>
          </div>
        </div>
      </div>

      <BottomNav />
    </div>
  );
}